/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

export const columns = (
  setOpenEditShippingAddress,
  setRetryWmsOrderNo,
  handleRetryClick,
  integrationType,
) => [
  {
    customWidth: 200,
    Header: () => 'WMS Order #',
    accessor: 'orderNo',
    Cell: ({ row }) => (
      <div
        onClick={() => {
          row.original.status === 'Failed' && setOpenEditShippingAddress(true)
          setRetryWmsOrderNo({
            wmsOrderNo: row.original.wmsOrderNo,
            warehouseOrderId: row.original.warehouseOrderId,
          })
        }}
        style={{
          cursor: 'pointer',
          color: 'black',
          textDecoration: 'none',
        }}>
        <span
          style={{
            display: 'inline-block',
          }}
          onMouseEnter={(e) => {
            e.target.style.fontWeight = 'bold'
            e.target.style.textDecoration = 'underline'
          }}
          onMouseLeave={(e) => {
            e.target.style.fontWeight = 'normal'
            e.target.style.textDecoration = 'none'
          }}>
          {row.original.wmsOrderNo}
        </span>
      </div>
    ),
  },
  ...(integrationType === 'Paperless'
    ? [
        {
          id: 'consNo',
          customWidth: 100,
          Header: 'Cons No',
          accessor: 'consNo',
          Cell: ({ row }) => <div>{row.original.consNo}</div>,
        },
      ]
    : [
        {
          id: 'bulkSlipNo',
          customWidth: 100,
          Header: 'Bulk Slip No',
          accessor: 'bulkSlipNo',
          Cell: ({ row }) => <div>{row.original.bulkSlipNo}</div>,
        },
      ]),
  {
    id: 'status',
    customWidth: 60,
    Header: 'Status',
    accessor: 'status',
    Cell: ({ row }) => (
      <div>
        {row.original.status === 'Completed' && (
          <span
            style={{
              color: '#11a651',
              fontSize: '14px',
              fontWeight: '600',
            }}>
            Completed
          </span>
        )}
        {row.original.status === 'Failed' && (
          <span
            style={{
              color: '#8a0e0e',
              fontSize: '14px',
              fontWeight: '600',
            }}>
            Failed
          </span>
        )}
      </div>
    ),
  },
  {
    id: 'description',
    customWidth: 256,
    Header: () => 'Description',
    accessor: 'description',
    Cell: ({ row }) => {
      const error = row.original.errorReason || '' // Ensure it's a string
      const match = error.match(/:(.*?)\./) // Extract between ': ' and first '.'

      const extractedStatus = match ? match[1].trim() : error // Use extracted value or full text as fallback

      return (
        <div className='h-[60px] overflow-y-auto whitespace-pre-wrap p-2 bg-gray-100 rounded-md custom-scroll'>
          {extractedStatus}
        </div>
      )
    },
  },
  {
    id: 'Action',
    customWidth: 150,
    Header: () => 'Action',
    accessor: 'action',
    Cell: ({ row }) => {
      if (row.original.status === 'Failed') {
        return (
          <button
            style={{
              backgroundColor: 'white', //#F1A248
              color: '#F1A248',
              border: 'none',
              padding: '8px 12px',
              borderRadius: '5px',
              cursor: 'pointer',
              WebkitAppearance: 'button',
              backgroundImage: 'none',
            }}
            onMouseEnter={(e) => {
              e.target.style.color = 'black'
              e.target.style.textDecoration = 'underline'
            }}
            onMouseLeave={(e) => {
              e.target.style.color = '#F1A248'
              e.target.style.textDecoration = 'none'
            }}
            onClick={(e) => {
              e.stopPropagation()
              handleRetryClick(row.original.wmsOrderNo)
              e.preventDefault()
            }}>
            Retry
          </button>
        )
      }
      return null // Ensure a return value
    },
  },
]

export default columns
